import { ModalDataTypes, ModalId } from "./models.ts";

export const enum ModalEvents {
  OPEN = "modal_open",
  CLOSE = "modal_close",
}

export type ModalOpenEvent<D = NonNullable<unknown>> = {
  type: ModalEvents.OPEN;
  modalId: string;
  data: D;
};

export type ModalCloseEvent = {
  type: ModalEvents.CLOSE;
};

export type ProModalTriggeredBy =
  | "secret_mission_unlock"
  | "portfolio_add_project_limit"
  | "pro_project_unlock"
  | "validation_edit"
  | "validation_text_limit"
  | "share_add_project_limit"
  | "project_share_theme_select"
  | "project_share_url"
  | "project_quiz"
  | "project_reset"
  | "nav_explore_your_potential_button";

export function openModal<M extends ModalId>(modalId: M, data: ModalDataTypes[M]) {
  const eventData: ModalOpenEvent<ModalDataTypes[M]> = {
    type: ModalEvents.OPEN,
    modalId: modalId,
    data: data,
  };

  const openEvent = new CustomEvent(ModalEvents.OPEN, { detail: eventData });
  dispatchEvent(openEvent);
}

export function closeModal() {
  const eventData: ModalCloseEvent = {
    type: ModalEvents.CLOSE,
  };

  const closeEvent = new CustomEvent(ModalEvents.CLOSE, { detail: eventData });
  dispatchEvent(closeEvent);
}

/**
 * Opens the paywall modal.
 * @param triggeredBy tracks the source or action that triggered the Pro modal to open
 * @param analyticsInfo additional analytics data to send with the tracking event
 */
export function openProModal(triggeredBy?: ProModalTriggeredBy, analyticsInfo: Record<string, string> = {}) {
  openModal("paywall", {});

  if (triggeredBy) {
    import("@/services/analyticsService").then(({ useAnalyticsService }) => {
      useAnalyticsService().trackPaywallTriggered(triggeredBy, analyticsInfo);
    });
  }
}

export function openLoginModal() {
  openModal("login", {});
}
